import { gridSize } from '@atlassian/jira-common-styles/src';

export const TABLE_BUTTON_OUTLINE = `${gridSize / 4}px`; // to not crop outline border on button's focus
export const ACTIONS_CELL_PADDING = `${gridSize / 2}px`; // should be at least TABLE_BUTTON_OUTLINE, not to crop outline border on button's focus
export const FAVOURITE_CELL_WIDTH = `${gridSize * 4}px`; // width of the favouriting button which appears in each row
